import React, { Component } from "react";
import "../../App.css";
import {
    getTriggers,
    updateTriggerQuantity,
    switchTriggerType,
    updateTrigger,
    updateTriggerConfig,
} from "../../Api/Http";
import triggersConfig from "../../config/triggers.json";
import defaultConfig from "../../config/default.json";
import { sort, executeFunction, roundOff } from "../../Utils/utils";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import AppConstants from "../../Constants/AppConstants";
const getAppConstants = new AppConstants().getAppConstants;

class Triggers extends Component {
    async componentDidMount() {
        const decreaseQuantity = async value => {
            value.quantity = value.quantity - 1;
            const resp = await executeFunction({
                reference: updateTriggerQuantity,
                body: value,
            });
            return resp;
        };

        const increaseQuantity = async value => {
            value.quantity = value.quantity + 1;
            const resp = await executeFunction({
                reference: updateTriggerQuantity,
                body: value,
            });
            return resp;
        };

        const updateQuantity = async value => {
            const resp = await executeFunction({
                reference: updateTriggerQuantity,
                body: value,
            });
            return resp;
        };

        const onClickOfUpdateTrigger = async ({ value }) => {
            const { data } = value;
            let shouldMakeCall = false;
            for (const key in this.state.updatedValues[data.id]) {
                if (this.state.updatedValues[data.id][key] !== undefined) {
                    if (data[key] !== this.state.updatedValues[data.id][key]) {
                        shouldMakeCall = true;
                        data[key] = this.state.updatedValues[data.id][key];
                    }
                }
            }
            if (shouldMakeCall) {
                await executeFunction({ reference: updateTrigger, body: data });
            }
        };

        const onClickOfUpdateTriggerConfig = async ({ value }) => {
            const { data } = value;
            let shouldMakeCall = false;
            if (!data.gttConfig) {
                data.gttConfig = {};
            }
            for (const key in this.state.updatedValues[data.id]) {
                if (this.state.updatedValues[data.id][key] !== undefined) {
                    if (data.gttConfig[key] !== this.state.updatedValues[data.id][key]) {
                        shouldMakeCall = true;
                        data.gttConfig[key] = this.state.updatedValues[data.id][key];
                    }
                }
            }
            if (shouldMakeCall) {
                await executeFunction({
                    reference: updateTriggerConfig,
                    body: data.gttConfig,
                });
            }
        };

        const getMappedTriggers = async () => {
            const getTriggersResp = await getTriggers();
            const resp = getTriggersResp.map(value => {
                return {
                    tradingsymbol: value.tradingsymbol,
                    dayChangePercentage: roundOff(value.day_change_percentage),
                    afterPercent: value.gttConfig && value.gttConfig.afterPercent,
                    increaseQuantityBy: value.gttConfig && value.gttConfig.increaseQuantityBy,
                    consecutiveHit: value.gttConfig && value.gttConfig.consecutiveHit,
                    distanceInPercent: value.gttConfig && value.gttConfig.distanceInPercent,
                    instrumentType:
                        value.gttConfig && value.gttConfig.instrumentType
                            ? value.gttConfig.instrumentType
                            : value.gttConfig && value.gttConfig.isEtf
                            ? value.gttConfig.isEtf
                                ? "etf"
                                : "stock"
                            : "stock",
                    minInvestment:
                        value.gttConfig && value.gttConfig.minInvestment !== undefined
                            ? value.gttConfig.minInvestment
                            : 1200,
                    gttCount: value.gttConfig && value.gttConfig.gttCount !== undefined ? value.gttConfig.gttCount : 1,
                    price: parseFloat(value.price, 10),
                    priceQty: parseFloat((parseFloat(value.price, 10) * parseFloat(value.quantity, 10)).toFixed(2), 10),
                    quantity: value.quantity,
                    totalCost: parseFloat(
                        (parseFloat(value.quantity, 10) * parseFloat(value.triggerPrice, 10)).toFixed(2),
                        10,
                    ),
                    percent: parseFloat(
                        (
                            ((parseFloat(value.lastPrice, 10) - parseFloat(value.price, 10)) /
                                parseFloat(value.lastPrice, 10)) *
                            100
                        ).toFixed(2),
                        10,
                    ),
                    data: value,
                };
            });
            this.setState({ getMappedTriggersResp: resp });
            this.setState({ triggersCount: resp.length });
            return resp;
        };

        let getMappedTriggersResp = await getMappedTriggers();
        const transitTrigger = async data => {
            const resp = await executeFunction({
                reference: switchTriggerType,
                body: data,
            });
            // await getMappedTriggers();
            return resp;
        };

        const ordering = async ({ key, type }) => {
            if (type === defaultConfig.order.type.ascending) {
                this.state.visibility[key][defaultConfig.order.type.descending] = true;
                getMappedTriggersResp = sort({
                    data: getMappedTriggersResp,
                    key,
                    type,
                });
            }
            if (type === defaultConfig.order.type.descending) {
                this.state.visibility[key][defaultConfig.order.type.ascending] = true;
                getMappedTriggersResp = sort({
                    data: getMappedTriggersResp,
                    key,
                    type,
                });
            }
            this.state.visibility[key][type] = !this.state.visibility[key][type];
            this.setState({ getMappedTriggersResp: getMappedTriggersResp });
            this.setState({ visibility: this.state.visibility });
        };

        const setDefaultVisibilityOfColumns = () => {
            const obj = {};
            for (const iterator of Object.keys(triggersConfig.page.columns)) {
                if (!obj[iterator]) {
                    obj[iterator] = {};
                }
                for (const orderIterator of Object.keys(defaultConfig.order.type)) {
                    if (defaultConfig.order.type.ascending === orderIterator) {
                        obj[iterator][orderIterator] = true;
                    } else {
                        obj[iterator][orderIterator] = false;
                    }
                }
            }
            return obj;
        };

        this.setState({ order: ordering });
        this.setState({ transitTrigger: transitTrigger });
        this.setState({ increaseQuantity: increaseQuantity });
        this.setState({ updateQuantity: updateQuantity });
        this.setState({ decreaseQuantity: decreaseQuantity });
        this.setState({ onClickOfUpdateTrigger: onClickOfUpdateTrigger });
        this.setState({
            onClickOfUpdateTriggerConfig: onClickOfUpdateTriggerConfig,
        });
        this.setState({ updatedValues: {} });
        this.setState({ visibility: setDefaultVisibilityOfColumns() });
    }
    render() {
        let getMappedTriggersResp;
        if (this.state && this.state.getMappedTriggersResp && this.state.getMappedTriggersResp) {
            //headers
            getMappedTriggersResp = [
                <div>
                    <tr>
                        {Object.keys(triggersConfig.page.columns).map(value => (
                            <th className="triggers-table-columns-heading">
                                {triggersConfig.page.columns[value].name}
                                {this.state.visibility &&
                                    this.state.visibility[value] &&
                                    this.state.visibility[value]["ascending"] && (
                                        <button
                                            onClick={() =>
                                                this.state.order({
                                                    data: this.state.getMappedTriggersResp,
                                                    key: value,
                                                    type: defaultConfig.order.type.ascending,
                                                })
                                            }>
                                            &#9650;
                                        </button>
                                    )}
                                {this.state.visibility &&
                                    this.state.visibility[value] &&
                                    this.state.visibility[value]["descending"] && (
                                        <button
                                            onClick={() =>
                                                this.state.order({
                                                    data: this.state.getMappedTriggersResp,
                                                    key: value,
                                                    type: defaultConfig.order.type.descending,
                                                })
                                            }>
                                            &#9660;
                                        </button>
                                    )}
                            </th>
                        ))}
                    </tr>
                </div>,
            ];
            //data
            getMappedTriggersResp.push(
                ...this.state.getMappedTriggersResp.map(value => (
                    <div id={value.id}>
                        <tr>
                            <td className="triggers-table-rows">
                                <span>{value.tradingsymbol.substring(0, 10)}</span>
                            </td>
                            <td className="triggers-table-rows">
                                <button
                                    className="transit-trigger-button"
                                    onClick={() => this.state.transitTrigger(value.data)}>
                                    &#8594;
                                </button>
                                {/* <span className="quantity-display">{value.consecutiveHit}</span> */}
                                <Popup
                                    key={value.id + "_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    trigger={<button> {value.consecutiveHit} </button>}
                                    position="center center">
                                    <div>
                                        <input
                                            key={value.id + "_input"}
                                            className="target-input-box"
                                            type="text"
                                            defaultValue={value.consecutiveHit}
                                            onChange={event => {
                                                if (event && event.target && event.target.value) {
                                                    const updatedValues = this.state.updatedValues;
                                                    if (updatedValues) {
                                                        if (!updatedValues[value.data.id]) {
                                                            updatedValues[value.data.id] = {};
                                                        }
                                                        updatedValues[value.data.id].consecutiveHit = Math.max(
                                                            event.target.value,
                                                            0,
                                                        );
                                                        this.setState({
                                                            updatedValues: updatedValues,
                                                        });
                                                    }
                                                }
                                                return;
                                            }}
                                        />
                                    </div>
                                    <span>
                                        {
                                            <button
                                                onClick={() =>
                                                    this.state.onClickOfUpdateTriggerConfig({
                                                        value,
                                                    })
                                                }>
                                                &#x2714;
                                            </button>
                                        }
                                    </span>
                                </Popup>

                                <span>({value.data.triggerType.substring(0, 1).toUpperCase()})</span>
                            </td>
                            <td className="triggers-table-rows">
                                <Popup
                                    key={value.id + "_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    trigger={<button> {value.distanceInPercent} </button>}
                                    position="center center">
                                    <div>
                                        <input
                                            key={value.id + "_input"}
                                            className="target-input-box"
                                            type="text"
                                            defaultValue={value.distanceInPercent}
                                            onChange={event => {
                                                if (event && event.target && event.target.value) {
                                                    const updatedValues = this.state.updatedValues;
                                                    if (updatedValues) {
                                                        if (!updatedValues[value.data.id]) {
                                                            updatedValues[value.data.id] = {};
                                                        }
                                                        updatedValues[value.data.id].distanceInPercent =
                                                            event.target.value;
                                                        this.setState({
                                                            updatedValues: updatedValues,
                                                        });
                                                    }
                                                }
                                                return;
                                            }}
                                        />
                                    </div>
                                    <span>
                                        {
                                            <button onClick={() => this.state.onClickOfUpdateTriggerConfig({ value })}>
                                                &#x2714;
                                            </button>
                                        }
                                    </span>
                                </Popup>
                            </td>
                            <td className="triggers-table-rows">
                                <Popup
                                    key={value.id + "_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    trigger={<button> {value.price || "-"} </button>}
                                    position="center center">
                                    <div>
                                        <input
                                            key={value.id + "_input"}
                                            className="target-input-box"
                                            type="text"
                                            defaultValue={value.price || "-"}
                                            onChange={event => {
                                                if (event && event.target && event.target.value) {
                                                    const updatedValues = this.state.updatedValues;
                                                    if (updatedValues) {
                                                        if (!updatedValues[value.data.id]) {
                                                            updatedValues[value.data.id] = {};
                                                        }
                                                        updatedValues[value.data.id].price = event.target.value;
                                                        this.setState({
                                                            updatedValues: updatedValues,
                                                        });
                                                    }
                                                }
                                                return;
                                            }}
                                        />
                                    </div>
                                    <span>
                                        {
                                            <button onClick={() => this.state.onClickOfUpdateTrigger({ value })}>
                                                &#x2714;
                                            </button>
                                        }
                                    </span>
                                </Popup>
                            </td>
                            <td className="triggers-table-rows">{value.priceQty || "-"}</td>
                            <td className="triggers-table-rows">
                                <button
                                    onClick={() =>
                                        setTimeout(() => {
                                            this.state.decreaseQuantity(value.data);
                                        }, getAppConstants.quantity.debounceTime)
                                    }>
                                    -
                                </button>
                                <Popup
                                    key={value.id + "_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    trigger={<button> {value.quantity || "-"} </button>}
                                    position="center center">
                                    <div>
                                        <input
                                            key={value.id + "_input"}
                                            className="target-input-box"
                                            type="text"
                                            defaultValue={value.quantity || "-"}
                                            onChange={event => {
                                                if (event && event.target && event.target.value) {
                                                    const updatedValues = this.state.updatedValues;
                                                    if (updatedValues) {
                                                        if (!updatedValues[value.data.id]) {
                                                            updatedValues[value.data.id] = {};
                                                        }
                                                        updatedValues[value.data.id].quantity = Math.max(
                                                            event.target.value,
                                                            1,
                                                        );
                                                        this.setState({
                                                            updatedValues: updatedValues,
                                                        });
                                                    }
                                                }
                                                return;
                                            }}
                                        />
                                    </div>
                                    <span>
                                        {
                                            <button
                                                onClick={() =>
                                                    this.state.onClickOfUpdateTrigger({
                                                        value,
                                                    })
                                                }>
                                                &#x2714;
                                            </button>
                                        }
                                    </span>
                                </Popup>
                                <button
                                    onClick={() =>
                                        setTimeout(() => {
                                            this.state.increaseQuantity(value.data);
                                        }, getAppConstants.quantity.debounceTime)
                                    }>
                                    +
                                </button>
                            </td>

                            <td className="triggers-table-rows">
                                <Popup
                                    key={value.id + "_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    trigger={<button> {value.increaseQuantityBy || "-"} </button>}
                                    position="center center">
                                    <div>
                                        <input
                                            key={value.id + "_input"}
                                            className="target-input-box"
                                            type="text"
                                            defaultValue={value.increaseQuantityBy || "-"}
                                            onChange={event => {
                                                if (event && event.target && event.target.value) {
                                                    const updatedValues = this.state.updatedValues;
                                                    if (updatedValues) {
                                                        if (!updatedValues[value.data.id]) {
                                                            updatedValues[value.data.id] = {};
                                                        }
                                                        updatedValues[value.data.id].increaseQuantityBy =
                                                            event.target.value;
                                                        this.setState({
                                                            updatedValues: updatedValues,
                                                        });
                                                    }
                                                }
                                                return;
                                            }}
                                        />
                                    </div>
                                    <span>
                                        {
                                            <button
                                                onClick={() =>
                                                    this.state.onClickOfUpdateTriggerConfig({
                                                        value,
                                                    })
                                                }>
                                                &#x2714;
                                            </button>
                                        }
                                    </span>
                                </Popup>
                            </td>

                            <td className="triggers-table-rows">
                                <Popup
                                    key={value.id + "_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    trigger={<button> {value.afterPercent || "-"} </button>}
                                    position="center center">
                                    <div>
                                        <input
                                            key={value.id + "_input"}
                                            className="target-input-box"
                                            type="text"
                                            defaultValue={value.afterPercent || "-"}
                                            onChange={event => {
                                                if (event && event.target && event.target.value) {
                                                    const updatedValues = this.state.updatedValues;
                                                    if (updatedValues) {
                                                        if (!updatedValues[value.data.id]) {
                                                            updatedValues[value.data.id] = {};
                                                        }
                                                        updatedValues[value.data.id].afterPercent = event.target.value;
                                                        this.setState({
                                                            updatedValues: updatedValues,
                                                        });
                                                    }
                                                }
                                                return;
                                            }}
                                        />
                                    </div>
                                    <span>
                                        {
                                            <button
                                                onClick={() =>
                                                    this.state.onClickOfUpdateTriggerConfig({
                                                        value,
                                                    })
                                                }>
                                                &#x2714;
                                            </button>
                                        }
                                    </span>
                                </Popup>
                            </td>
                            <td className="triggers-table-rows">
                                <Popup
                                    key={value.id + "_instrumentType_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    trigger={<button> {value.instrumentType || "stock"} </button>}
                                    position="center center">
                                    <div>
                                        <select
                                            key={value.id + "_instrumentType_select"}
                                            className="target-input-box"
                                            defaultValue={value.instrumentType || "stock"}
                                            onChange={event => {
                                                const newValue = event.target.value;
                                                const updatedValues = this.state.updatedValues;
                                                if (updatedValues) {
                                                    if (!updatedValues[value.data.id]) {
                                                        updatedValues[value.data.id] = {};
                                                    }
                                                    updatedValues[value.data.id].instrumentType = newValue;

                                                    const updatedTriggers = this.state.getMappedTriggersResp.map(
                                                        trigger => {
                                                            if (trigger.data && trigger.data.id === value.data.id) {
                                                                return {
                                                                    ...trigger,
                                                                    instrumentType: newValue,
                                                                };
                                                            }
                                                            return trigger;
                                                        },
                                                    );

                                                    this.setState({
                                                        updatedValues: updatedValues,
                                                        getMappedTriggersResp: updatedTriggers,
                                                    });
                                                    this.state.onClickOfUpdateTriggerConfig({ value });
                                                }
                                                return;
                                            }}>
                                            <option value="stock">stock</option>
                                            <option value="etf">etf</option>
                                        </select>
                                    </div>
                                    <span>
                                        {
                                            <button
                                                onClick={() =>
                                                    this.state.onClickOfUpdateTriggerConfig({
                                                        value,
                                                    })
                                                }>
                                                &#x2714;
                                            </button>
                                        }
                                    </span>
                                </Popup>
                            </td>
                            <td className="triggers-table-rows">
                                <Popup
                                    key={value.id + "_minInvestment_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    trigger={<button> {value.minInvestment || "-"} </button>}
                                    position="center center">
                                    <div>
                                        <input
                                            key={value.id + "_minInvestment_input"}
                                            className="target-input-box"
                                            type="text"
                                            defaultValue={value.minInvestment || "-"}
                                            onChange={event => {
                                                if (event && event.target && event.target.value) {
                                                    const updatedValues = this.state.updatedValues;
                                                    if (updatedValues) {
                                                        if (!updatedValues[value.data.id]) {
                                                            updatedValues[value.data.id] = {};
                                                        }
                                                        updatedValues[value.data.id].minInvestment = Math.max(
                                                            parseInt(event.target.value) || 0,
                                                            0,
                                                        );
                                                        this.setState({
                                                            updatedValues: updatedValues,
                                                        });
                                                    }
                                                }
                                                return;
                                            }}
                                        />
                                    </div>
                                    <span>
                                        {
                                            <button
                                                onClick={() =>
                                                    this.state.onClickOfUpdateTriggerConfig({
                                                        value,
                                                    })
                                                }>
                                                &#x2714;
                                            </button>
                                        }
                                    </span>
                                </Popup>
                            </td>
                            <td className="triggers-table-rows">
                                <Popup
                                    key={value.id + "_gttCount_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    trigger={<button> {value.gttCount || "-"} </button>}
                                    position="center center">
                                    <div>
                                        <input
                                            key={value.id + "_gttCount_input"}
                                            className="target-input-box"
                                            type="text"
                                            defaultValue={value.gttCount || "-"}
                                            onChange={event => {
                                                if (event && event.target && event.target.value) {
                                                    const updatedValues = this.state.updatedValues;
                                                    if (updatedValues) {
                                                        if (!updatedValues[value.data.id]) {
                                                            updatedValues[value.data.id] = {};
                                                        }
                                                        updatedValues[value.data.id].gttCount = Math.max(
                                                            parseInt(event.target.value) || 1,
                                                            1,
                                                        );
                                                        this.setState({
                                                            updatedValues: updatedValues,
                                                        });
                                                    }
                                                }
                                                return;
                                            }}
                                        />
                                    </div>
                                    <span>
                                        {
                                            <button
                                                onClick={() =>
                                                    this.state.onClickOfUpdateTriggerConfig({
                                                        value,
                                                    })
                                                }>
                                                &#x2714;
                                            </button>
                                        }
                                    </span>
                                </Popup>
                            </td>
                            <td className="triggers-table-rows">
                                {value.percent}%({value.dayChangePercentage})
                            </td>
                        </tr>
                    </div>
                )),
            );
        }
        return (
            <div>
                <div>
                    <header>
                        <h1>Triggers ({(this.state && this.state.triggersCount) || 0})</h1>
                    </header>
                </div>
                <div>
                    <header className="triggers-table">
                        <table>{getMappedTriggersResp}</table>
                    </header>
                </div>
                <ToastContainer />
            </div>
        );
    }
}

export default Triggers;
